import { AutoSubmitToggleListener } from "./auto-submit-toggle-listener";

export class AutoSubmitToggleSetup {
    public static init(el: Element): void {
        if (!(el instanceof HTMLInputElement)) return;

        AutoSubmitToggleListener.bindChange(el, () => {
            const form = el.form;
            if (!(form instanceof HTMLFormElement)) return;

            if (typeof form.requestSubmit === "function") {
                form.requestSubmit();
            } else {
                form.submit();
            }
        });
    }
}
